import React, { useState, useEffect } from "react";
import { useLoading } from "./LoadingContext";

const LoadingControl = () => {
  const { isLoading } = useLoading();
  const [isVisible, setIsVisible] = useState(false);
  const [hasAppeared, setHasAppeared] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setIsVisible(true);
      setTimeout(() => setHasAppeared(true), 500); // Delay to match appear animation duration
    } else {
      setHasAppeared(false);
      const timer = setTimeout(() => setIsVisible(false), 500); // Delay to allow shrinking animation
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <svg
        viewBox="0 0 45 45"
        xmlns="http://www.w3.org/2000/svg"
        className={`w-20 h-20 ${
          isLoading
            ? hasAppeared
              ? 'animate-natural-spin'
              : 'animate-natural-appear'
            : 'animate-natural-shrink'
        }`}
      >
        <defs>
          <style>
            {`
              .solid-white { fill: #ffffff; }
              .outline-white { fill: none; stroke: #ffffff; stroke-width: 0.5; }
              @keyframes naturalAppear {
                0% { transform: scale(0) rotate(0deg); opacity: 0; }
                100% { transform: scale(1) rotate(360deg); opacity: 1; }
              }
              @keyframes naturalSpin {
                0% { transform: rotate(0deg); }
                25% { transform: rotate(90deg); }
                50% { transform: rotate(180deg); }
                75% { transform: rotate(270deg); }
                100% { transform: rotate(360deg); }
              }
              @keyframes naturalShrink {
                0% { transform: scale(1) rotate(0deg); opacity: 1; }
                100% { transform: scale(0) rotate(360deg); opacity: 0; }
              }
              .animate-natural-appear {
                animation: naturalAppear 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
              }
              .animate-natural-spin {
                animation: naturalSpin 4s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
              }
              .animate-natural-shrink {
                animation: naturalShrink 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) forwards;
              }
            `}
          </style>
        </defs>
        <g transform="translate(4.5, 2.5)">
          <path className="solid-white" d="M13.513 15.903C15.044 17.616 16.135 19.675 16.693 21.903C16.984 23.682 16.2 25.465 14.693 26.453L5.323 33.933V27.643L10.533 23.483C10.533 23.483 15.153 19.683 13.533 15.903"/>
          <path className="outline-white" d="M5.333 11.873L9.873 17.603C10.723 18.562 11.33 19.711 11.643 20.953C11.794 21.771 11.515 22.609 10.903 23.173C11.953 22.173 14.903 19.063 13.513 15.913L5.333 5.593V11.873Z"/>
          <path className="solid-white" d="M19.253 27.613C19.963 25.432 21.192 23.455 22.833 21.853C24.217 20.701 26.15 20.474 27.763 21.273L38.943 25.613L33.513 28.773L27.303 26.363C27.303 26.363 21.693 24.283 19.303 27.613"/>
          <path className="outline-white" d="M19.883 36.713L22.553 29.913C22.954 28.698 23.639 27.598 24.553 26.703C25.184 26.162 26.05 25.984 26.843 26.233C25.453 25.823 21.283 24.863 19.253 27.623L14.453 39.883L19.883 36.713Z"/>
          <path className="solid-white" d="M26.493 16.803C24.246 17.266 21.92 17.18 19.713 16.553C18.004 15.938 16.825 14.365 16.713 12.553L15.023 0.713L20.473 3.853L21.473 10.443C21.473 10.443 22.473 16.343 26.563 16.803"/>
          <path className="outline-white" d="M34.023 11.713L26.793 12.783C25.54 13.042 24.243 12.994 23.013 12.643C22.231 12.363 21.647 11.703 21.463 10.893C21.803 12.303 23.043 16.393 26.463 16.783L39.463 14.843L34.023 11.713Z"/>
        </g>
      </svg>
    </div>
  );
};

export default LoadingControl;